import { defineStore } from 'pinia'
import { addressService } from '@/services/addresses'
import type { InvoiceAddress, InvoiceAddressPayload } from '@/types/api'

interface AddressState {
  items: InvoiceAddress[]
  ready: boolean
}

export const useAddressStore = defineStore('addresses', {
  state: (): AddressState => ({ items: [], ready: false }),

  actions: {
    async fetch(): Promise<void> {
      try {
        this.items = await addressService.list()
      } finally {
        this.ready = true
      }
    },

    async fetchOnce(): Promise<void> {
      if (this.ready) return
      await this.fetch()
    },

    async save(payload: InvoiceAddressPayload): Promise<InvoiceAddress> {
      const saved = await addressService.save(payload)
      await this.fetch()
      return saved
    },

    async remove(id: string): Promise<void> {
      await addressService.remove(id)
      await this.fetch()
    },
  },
})
